import {ILocalDataLayers} from "../services/local-data/service/LocalDataLayers";
import {Feature} from "ol";
import {BackgroundDataLoader} from "../services/local-data/service/BackgroundDataLoader";
import {MediaType} from "../services/local-data/data/MediaTypes";
import {IUsageLoggingService} from "../services/IUsageLoggingService";
import {Geometry} from "ol/geom";

interface IFileType {
    id: string,
    label: string,
    extension?: string,
    mediaType?: string
}

interface AddLocalDataBindings {
    onSuccess(): void;
}

class AddLocalDataController implements ng.IComponentController, AddLocalDataBindings {
    constructor(protected localDataLayers: ILocalDataLayers,
                protected usageLogging: IUsageLoggingService) {
    }

    public file: File;
    public type: IFileType;
    public loading: boolean = false;
    public error: string;

    onSuccess: () => void;

    public handleFile(file: File, extraFiles: File[], fileType: IFileType, dataProjection: string) {
        this.loading = true;
        this.error = null;

        const ldl = new BackgroundDataLoader();
        ldl.loadFile(file, fileType.mediaType as MediaType, { featureProjection: "EPSG:2193", dataProjection: dataProjection || "EPSG:4326" }, extraFiles)
            .then(features => {
                    this.usageLogging.logWithAnalytics('LocalData', 'dataLoaded', file.type);
                    this.file = file;
                    this.type = fileType;
                    console.log(`AddLocalData: ${features.length} features loaded`);
                    this.localDataLayers.addLayer(file, features as Feature<Geometry>[]);
                    this.onSuccess();
                },
                err => {
                    this.usageLogging.logWithAnalytics('LocalData', 'errorLoadingData', file.type);
                    this.error = `${err}`.trim().split('\n')[0];
                }
            )
            .finally(() => {
                this.loading = false;
            });

    }
}

export class AddLocalData implements ng.IComponentOptions {
    controller = ['localDataLayers', 'usageLoggingService', AddLocalDataController];

    bindings = {
        onSuccess: '&'
    }

    templateUrl = '/Partial/component/AddLocalData'
}